import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import FormItem from '../general/formitem.js';

export default class RegisterOrg extends React.Component
{
    constructor(props)
    {
        super(props);
        this.inputChanged = this.inputChanged.bind(this);
        this.phoneInputChanged = this.phoneInputChanged.bind(this);
        this.state = {
            loaded: false,
            error: false,
            formMessage: "",
            success: false,
            states: [],
            validationErrors: [],
            submissionAttempted: false,
            formData: {
                organizationName: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                zipcode: "",
                phone: "",
                
                username: "",
                email: "",
                password: "",
                confirmpassword: ""
            }
        };
    }
    componentDidMount()
    {
        this.props.api.send({
            controller: "Registration",
            action: "GetStates",
            method: "GET",
            success: (data) => this.setState({states: data, loaded: true}),
            error: (error) => this.setState({error: true, loaded: true})
        });
    }
    validate()
    {
        if (this.state.submissionAttempted) 
        {
            var errors = [];
            if (this.state.formData.organizationName.trim() === "")
            {
                errors.push({message: "Organization Name is required.", element: "organizationName"});
            }
            if (this.state.formData.address1.trim() === "")
            {
                errors.push({message: "Address is required.", element: "address1"});
            }
            if (this.state.formData.city.trim() === "")
            {
                errors.push({message: "City is required.", element: "city"});
            }
            if (this.state.formData.state.trim() === "")
            {
                errors.push({message: "State is required.", element: "state"});
            }
            if (this.state.formData.zipcode.trim() === "")
            {
                errors.push({message: "Zipcode is required.", element: "zipcode"});
            }
            if (this.state.formData.username.trim() === "")
            {
                errors.push({message: "Admin username is required.", element: "username"});
            }
            if (this.state.formData.email.trim() === "")
            {
                errors.push({message: "Admin email is required.", element: "email"});
            }
            if (this.state.formData.password.trim() === "")
            {
                errors.push({message: "Admin password is required.", element: "password"});
            }
            if (this.state.formData.confirmpassword !== this.state.formData.password)
            {
                errors.push({message: "Confirm password and password do not match.", element: "confirmpassword"})
            }
            this.setState({validationErrors: errors});
            if (errors.length > 0)
            {
                return false
            }
        }
        return true;
    }
    inputChanged(event)
    {
        var data = this.state.formData;
        data[event.target.name] = event.target.value;
        this.setState({formData: data}, () => this.validate());
    }
    phoneInputChanged(value)
    {
        var data = this.state.formData;
        data.phone = value;
        this.setState({formData: data}, () => this.validate());
    }
    submitRegistration(event)
    {
        event.preventDefault();
        this.setState({submissionAttempted: true}, () => this.register())
    }
    register()
    {
        if (this.validate())
        {
            const orgData = {
                organizationName: this.state.formData.organizationName,
                address1: this.state.formData.address1,
                address2: this.state.formData.address2,
                city: this.state.formData.city,
                state: this.state.formData.state,
                zipcode: this.state.formData.zipcode,
                phone: this.state.formData.phone,
                admin: {
                    username: this.state.formData.username,
                    email: this.state.formData.email,
                    password: this.state.formData.password,
                    address: this.state.formData.address1,
                    address2: this.state.formData.address2,
                    city: this.state.formData.city,
                    state: this.state.formData.state,
                    zipcode: this.state.formData.zipcode
                }
            };
            this.setState({loaded: false}, () => {
                this.props.api.send({
                    controller: "Registration",
                    action: "RegisterOrg",
                    method: "POST",
                    body: JSON.stringify(orgData),
                    success: (data) => {
                        if (data.success) 
                        {
                            this.setState({success: true, loaded: true});
                            this.resetForm();
                        }
                        else
                        {
                            this.setState({success: false, loaded: true, formMessage: data.message});
                        }
                    },
                    error: (err) => {
                        this.setState({success: false, loaded: true, formMessage: "An error occurred while registering this organization.  Please try again later."});
                    }
                });
            })
        }
    }
    resetForm()
    {
        var formData = {
            organizationName: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            zipcode: "",
            phone: "",
            
            username: "",
            email: "",
            password: "",
            confirmpassword: ""
        }
        this.setState({formData: formData, submissionAttempted: false});
    }
    render()
    {
        const states = this.state.states.map((state) => 
            <option key={state.abbreviation} value={state.abbreviation}>{state.name}</option>
        )
        return (
            <div className="lmsform">
                <div className="lmsformheading">
                    Organization Information
                </div>
                <div className="lmsformbody">
                    { this.state.loaded ? (
                        <div>
                            <div className="lmscenter">
                                <div className={this.state.success ? "lmsformmessage lmssuccess" : "lmsvalidationerror"}>
                                    {this.state.success ? (
                                        <Redirect to="/Login" />
                                        //<div>
                                        //    Organization registered. <Link className="bodylink" to="/Login">Click here</Link> to login.
                                        //</div>
                                    ) : this.state.formMessage}
                                    
                                </div>
                            </div>
                            <form className="lmsforminner" method="post" onSubmit={(e) => this.submitRegistration(e)}>
                                <FormItem label="Organization Name:" name="organizationName" type="text" 
                                    inputChanged={this.inputChanged} value={this.state.formData.organizationName} 
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Address:" name="address1" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.address1}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Address 2:" name="address2" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.address2} />
                                <FormItem label="City:" name="city" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.city}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="State:" name="state" type="select" options={states}
                                    inputChanged={this.inputChanged} value={this.state.formData.state}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Zip:" name="zipcode" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.zipcode}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Phone Number:" name="phone" type="phone"
                                    inputChanged={this.phoneInputChanged} value={this.state.formData.phone} />
                                <FormItem label="Username:" name="username" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.username}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Email Address:" name="email" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.email}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Password" name="password" type="password"
                                    inputChanged={this.inputChanged} value={this.state.formData.password}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Confirm Password:" name="confirmpassword" type="password"
                                    inputChanged={this.inputChanged} value={this.state.formData.confirmpassword}
                                    validationErrors={this.state.validationErrors} />
                                <div className="lmsvalidationerror">
                                    <span>{this.state.validationErrors.map((err) =>
                                        <p key={err.element}>{err.message}</p>
                                    )}</span>
                                </div>
                                <div className="lmsformfooter">
                                    <input type="submit" name="register" value="Register" className="lmsbutton" />
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="lmscenter">
                            <img src="/images/spinner.svg" alt="Loading..." />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/registration/registerorg.js